module.exports = __webpack_public_path__ + "static/courtneybarnett-webfont-04ef58e7568e1d243eadea2fdbca18a6.woff";